import { ActionMeta, MultiValue, PropsValue, SingleValue } from "react-select";
import { SelectOnChangeValue, SimpleSelectOptionType } from "./types";

export function mapToSimpleSelectOption<T>(value: T | null): SimpleSelectOptionType<T> | null {
  if (value === null) {
    return null;
  }
  return {
    value,
    label: `${value}`,
  };
}

export function mapValueToSimpleSelectOption<T>(value: PropsValue<T>): PropsValue<SimpleSelectOptionType<NonNullable<T>>> | undefined {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  if (Array.isArray(value)) {
    return value.map(x => mapToSimpleSelectOption(x)!) as MultiValue<SimpleSelectOptionType<NonNullable<T>>>;
  }
  return mapToSimpleSelectOption(value as SingleValue<NonNullable<T>>)!;
}

export function mapFromSimpleSelectOption<T, AT = never>(value: SimpleSelectOptionType<T> | AT): T | AT {
  if (value && value.hasOwnProperty("value")) {
    return (value as SimpleSelectOptionType<T>).value as T;
  }
  return value as AT;
}

export function mapValueFromSimpleSelectOption<T, IsMulti extends boolean = boolean>(value: SelectOnChangeValue<SimpleSelectOptionType<T>, IsMulti>): SelectOnChangeValue<T, IsMulti> {
  if (Array.isArray(value)) {
    return value.map(x => mapFromSimpleSelectOption<T>(x)) as SelectOnChangeValue<T, IsMulti>;
  } else {
    return (value === null ? null : mapFromSimpleSelectOption<T>(value as SimpleSelectOptionType<T>)) as SelectOnChangeValue<T, IsMulti>;
  }
}

export function convertActionMeta<T>(actionMeta: ActionMeta<SimpleSelectOptionType<T>>): ActionMeta<T> {
  return {
    ...actionMeta,
    option: mapFromSimpleSelectOption(actionMeta.option)!,
    removedValue: mapFromSimpleSelectOption(actionMeta.removedValue)!,
    removedValues: actionMeta.removedValues
      ? actionMeta.removedValues.map(x => mapFromSimpleSelectOption<T>(x)) as ReadonlyArray<T>
      : [],
  };
}